import { Component, inject, signal, ChangeDetectionStrategy } from '@angular/core';
import { Biggen } from "../directives/biggen";
import { TitleChange } from '../services/title-change';
import { Link } from "../directives/link";
import { RouterLink } from "@angular/router";

@Component({
  selector: 'app-before-jesus',
  imports: [Biggen, Link, RouterLink],
  templateUrl: './before-jesus.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './before-jesus.scss',
})
export class BeforeJesus {
  dynamicTitle = inject(TitleChange);
  
  constructor() {
    this.dynamicTitle.title(`Before Jesus`);
    this.dynamicTitle.description(`The concept of Jesus has been influenced by earlier mythological figures rather than being based on a historical person.`);
  }
}
